const cleanUrl = (url) => {
    const value = url === null || url === void 0 ? void 0 : url.trim();
    return value ? value : undefined;
};
export const normalizeExternalUrl = (url) => {
    const value = cleanUrl(url);
    if (!value)
        return undefined;
    return value.includes('://') || value.startsWith('//') ? value : `http://${value}`;
};
export const getTourPageUrl = (tour, configuration) => {
    var _a, _b, _c, _d;
    const priceItem = (_d = (_c = (_b = (_a = tour.variants) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.prices) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.priceItem;
    if (configuration.tourSearchUseStaticTourPages) {
        const staticUrl = cleanUrl(priceItem === null || priceItem === void 0 ? void 0 : priceItem.staticTourUrl);
        if (staticUrl)
            return staticUrl;
    }
    return cleanUrl(tour.descriptionUrl);
};
export const getHotelDescriptionPageUrl = (hotelDescription, configuration) => {
    if (configuration.tourSearchUseStaticHotelPages) {
        const staticUrl = cleanUrl(hotelDescription === null || hotelDescription === void 0 ? void 0 : hotelDescription.staticHotelUrl);
        if (staticUrl)
            return staticUrl;
    }
    return normalizeExternalUrl(hotelDescription === null || hotelDescription === void 0 ? void 0 : hotelDescription.homePage);
};
export const getTourHotelPageUrl = (tour, hotelService, configuration) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
    const hotelId = (_b = (_a = hotelService.accommodation) === null || _a === void 0 ? void 0 : _a.hotelId) !== null && _b !== void 0 ? _b : (_c = hotelService.hotelDescription) === null || _c === void 0 ? void 0 : _c.hotelId;
    const priceHotel = (_j = (_h = (_g = (_f = (_e = (_d = tour.variants) === null || _d === void 0 ? void 0 : _d[0]) === null || _e === void 0 ? void 0 : _e.prices) === null || _f === void 0 ? void 0 : _f[0]) === null || _g === void 0 ? void 0 : _g.priceItem) === null || _h === void 0 ? void 0 : _h.hotels) === null || _j === void 0 ? void 0 : _j.find(hotel => hotel.hotelId == hotelId);
    if (configuration.tourSearchUseStaticHotelPages) {
        const staticUrl = cleanUrl((_k = priceHotel === null || priceHotel === void 0 ? void 0 : priceHotel.staticHotelUrl) !== null && _k !== void 0 ? _k : (_l = hotelService.hotelDescription) === null || _l === void 0 ? void 0 : _l.staticHotelUrl);
        if (staticUrl)
            return staticUrl;
    }
    return normalizeExternalUrl((_m = priceHotel === null || priceHotel === void 0 ? void 0 : priceHotel.hotelUrl) !== null && _m !== void 0 ? _m : (_o = hotelService.hotelDescription) === null || _o === void 0 ? void 0 : _o.homePage);
};
